import { createFileRoute } from '@tanstack/react-router'
import { RatesRoute } from '@/features/rates/components/rates'

export const Route = createFileRoute('/_authenticated/dashboard/rates/')({
  component: RatesRoute,
})
